import { useContext, useState } from "react"
import getServices from "../services/getServices"
import { AuthContext } from "../contexts/auth"

const useTarefaFormularioState = () => {

    const { signOut } = useContext(AuthContext)
    const [tarefaFormulario, setTarefaFormulario] = useState([])
    const [tarefa, setTarefa] = useState([])    
    const [submit, setSubmit] = useState(false)


    const _getTarefaFormulario = async (id, tipoTarefa)=>{
        if (submit){
            return;
        }
        setSubmit(true)
        // As consultas são independentes: tarefas sem formulário ainda precisam
        // exibir corretamente local, usuário, entrada, saída e demais detalhes.
        const [result, result2] = await Promise.all([
            getServices(`admin/tarefasformulario/${id}/`),
            getServices(
                `admin/tarefas/${id}/`,
                tipoTarefa ? { tipotarefa: tipoTarefa } : undefined
            ),
        ])
        if (result.type === 'success'){
            setTarefaFormulario(result.data)                        
        }
        if (result2.type === 'success'){
            setTarefa(result2.data?.results?.[0] || result2.data || {})
        }
        if (result.data?.code === 'token_not_valid' || result2.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }
    return {
        tarefaFormulario: {value: tarefaFormulario, set:_getTarefaFormulario},
        tarefa: {value: tarefa, set: setTarefa},        
        submit: {value: submit, set: _getTarefaFormulario},
    }
}

export default useTarefaFormularioState
